import React, { useCallback } from 'react';

import { CustomEventNames, EventTypes, logRBIEvent } from 'features/analytics';

import { BottomSheet as BottomSheetPresentation } from 'components/ui/bottom-sheet';

import type { BottomSheetProps } from './types';

/** Keeps app event contracts outside the reusable presentation primitive. */
export const BottomSheet: React.FC<BottomSheetProps> = ({
  onOpenEventMessage,
  onCloseEventMessage,
  onClose,
  ...props
}) => {
  const handleOpen = useCallback(() => {
    logRBIEvent({
      name: CustomEventNames.ACTION_SHEET_VIEW,
      type: EventTypes.Other,
      attributes: { actionSheetHeader: onOpenEventMessage },
    });
  }, [onOpenEventMessage]);

  const handleClose = useCallback(() => {
    if (onCloseEventMessage) {
      logRBIEvent({
        name: CustomEventNames.ACTION_SHEET_DISMISS,
        type: EventTypes.Other,
        attributes: { actionSheetHeader: onCloseEventMessage },
      });
    }
    onClose?.();
  }, [onClose, onCloseEventMessage]);

  return <BottomSheetPresentation {...props} onOpen={handleOpen} onClose={handleClose} />;
};

export default BottomSheet;
